import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent {

  constructor(private ds: DataService) {

  }

  textinput: string = ""
  @Input("text") set text(v: string) {
    this.textinput = v;
  }

  @Output("updateValue") updateValue = new EventEmitter()

  updateItems(v: any) {
    this.ds.filter = v.value
    this.updateValue.emit({ value: v.value, page: 1 })
  }
}
